/**
 * Utility function to determine if E0 or in E1 and above.
 * When used with an 'if' block webpack bundler will remove
 * the if block for production builds (E1 and above).
 */
export default function isDev() {
  return process.env.NODE_ENV === 'development';
}
